(function (ShareWidget, $) {

  window.popupCenter = function(url, w, h) {
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, '', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    if (window.focus) {
        newWindow.focus();
    }
  }

  function prettifyCount(count) {
    count = count > 1000 ?
      count.toString().charAt(0) + '.' + count.toString().charAt(1) + 'k' :
      count;
    var i = 4 - count;
    while (i > 2) {
      count += ' &nbsp;'
      i--;
    }
    return count;
  }

  var initShareWidget = function () {
    $.get('https://graph.facebook.com/https://shop.soloshot.com')
      .done(function (response) {
        $('[data-share-facebook]').attr('data-count', prettifyCount(response.share.share_count));
      })

    $.ajax({
      url: 'https://api.pinterest.com/v1/urls/count.json?url=https://shop.soloshot.com',
      dataType: 'jsonp'
    }).done(function (response) {
      $('[data-share-pinterest]').attr('data-count', prettifyCount(984 + response.count));
    })
  };

  var bindUIActions = function () {
    document.querySelector('[data-share-facebook]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Facebook'
      });
      FB.ui({
        method: 'share',
        display: 'popup',
        href: window.location.href
      });
    }

    document.querySelector('[data-share-twitter]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Twitter'
      });
      var url = window.location.hostname;
      var text = 'Automatically capture, edit, share and manage professional-quality video with SOLOSHOT at ' + url + ' via @SOLOSHOTupdates';
      var shareUrl = "http://www.twitter.com/intent/tweet?text=" + encodeURIComponent(text);
      popupCenter(shareUrl, 600, 253)
    }

    document.querySelector('[data-share-email]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Email'
      });
      var url = window.location.hostname;
      var subject = 'Automatically capture, edit, share and manage professional-quality video with SOLOSHOT.';
      var body = 'Film yourself with SOLOSHOT, the Robot Cameraman. You wear the Tag, and the Base automatically pans, tilts & zooms to keep you in the camera\'s shot. See more at ' + url;
      window.location.href = "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
    }

    document.querySelector('[data-share-pinterest]').onclick = function (e) {
      e.preventDefault();
      ga('send', {
        hitType: 'event',
        eventCategory: 'Social',
        eventAction: 'Share',
        eventLabel: 'Pinterest'
      });
      PinUtils.pinOne({
        'url': window.location.hostname + "?utm_source=pinterest&utm_medium=pin&utm_campaign=share_widget",
        'media': '{{ "fb-open-graph.jpg" | asset_url }}',
        'description': 'Film yourself with SOLOSHOT, the Robot Cameraman. You wear the Tag, and the Base automatically pans, tilts & zooms to keep you in the camera\'s shot.'
      });
    }
  };

  ShareWidget.init = function () {
    bindUIActions();
    initShareWidget();
  };


}(window.ShareWidget = window.ShareWidget || {}, jQuery, undefined));